 <template>
  <div class="act-video" :style="info.css" data-info="info" @click.prevent="clickPlay()">
    <div class="play" style="display: block;" v-show="!playing"></div>
    <video ref="video" x5-video-player-type="h5" x5-video-player-fullscreen="true"
           preload="preload" :poster="info.actVideo.poster" webkit-playsinline="" playsinline=""
           :style="videoStyle" :id="'video'+info.actVideo.vid"></video>
  </div>
</template>

<script>
  import click_handler from '../../tools/mgtv/click'
  import {updatePlayerURL} from '../../tools/mgtv/video'

  export default {
    name: 'ActVideo',
    props: ['info'],
    data () {
      return {
        playing: false,
        videoInst: null,
        gact: window.gact
      }
    },
    methods: {
      clickPlay(){
        if (this.$refs.video.src) {
          this.play();
        } else {
          updatePlayerURL(this.info.actVideo.vid, 'video' + this.info.actVideo.vid, () => {
            this.play();
          });
        }
      },
      play(){
        const videoInst = this.$refs.video;
        if (gact.is_wx && typeof WeixinJSBridge === "undefined") {
          document.addEventListener("WeixinJSBridgeReady", () => {
            if (videoInst.paused || videoInst.ended) {
              videoInst.play();
            } else {
              videoInst.pause();
            }
          }, false);
        } else {

          if (videoInst.paused || videoInst.ended) {
            videoInst.play();
          } else {
            videoInst.pause();
          }
        }
      }
    },
    computed: {
      videoStyle(){
        return {
          backgroundImage: "url(" + this.info.actVideo.poster + ")",
          backgroundSize: "cover"
        }
      }
    },
    mounted(){
      updatePlayerURL(this.info.actVideo.vid, 'video' + this.info.actVideo.vid, () => {
        if (this.info.actVideo.autoplay) {
          this.play();
        }
      });

      this.$refs.video.addEventListener('playing', () => {
        this.playing = true
      }, true);
      this.$refs.video.addEventListener('pause', () => {
        this.playing = false
      }, true);
    }

  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  @import "../../share/mixins.styl"
  .act-video
    > video
      width 100%
      height 100%
      center()
      object-fit: fill
    > canvas
      width 100%
      height 100%
      center()
      background white

    .poster
      width 100%
      center()
      z-index 1

    .play
      center()
      background-image: url(https://act.mgtv.com/h5/t21/assets/images/play.png);
      background-size: contain;
      width 1.28rem
      height 1.28rem
      z-index 2
</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/ActVideo.vue